import React, { useState, useMemo } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, RadioGroup, FormControlLabel, Radio, Typography, TextField, Box, Button } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface ModelSelectorProps {
  models: string[]
  selectedModel: string
  onChange: (model: string) => void
}

export const ModelSelector = React.memo(function ModelSelector({ models, selectedModel, onChange }: ModelSelectorProps) {
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const pageSize = 10

  const filteredModels = useMemo(() => {
    return models.filter(model => model.toLowerCase().includes(search.toLowerCase()))
  }, [models, search])

  const totalPages = Math.ceil(filteredModels.length / pageSize)
  const visibleModels = filteredModels.slice(page * pageSize, page * pageSize + pageSize)

  return (
    <Accordion sx={{ mb: 2 }} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Select Model</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search models…"
          value={search}
          onChange={e => {
            setSearch(e.target.value)
            setPage(0) 
          }}
        />

        <RadioGroup value={selectedModel} onChange={e => onChange(e.target.value)}>
          {visibleModels.map(model => (
            <FormControlLabel key={model} value={model} control={<Radio />} label={model} />
          ))}
        </RadioGroup>

        {totalPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
            <Button variant="outlined" disabled={page === 0} onClick={() => setPage(p => p - 1)}>Prev</Button>
            <Typography>Page {page + 1} / {totalPages}</Typography>
            <Button variant="outlined" disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)}>Next</Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  )
})
